import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import DeptInfo from '@/types/table/deptInfo';
import { DeptCategoryData } from '@/api/generated/deptCategoryController';
import { PostData } from '@/api/generated/postController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface DeptInfoData extends DeptInfo {
  deptCategory?: DeptCategoryData;
  postList?: PostData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class DeptInfoController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<DeptInfoData>>(API_CONTEXT + '/app/deptInfo/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<DeptInfoData>(API_CONTEXT + '/app/deptInfo/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/deptInfo/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/deptInfo/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/deptInfo/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/deleteBatch', params, httpOptions);
  }
  static listDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/listDeptPost', params, httpOptions);
  }
  static listNotInDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/listNotInDeptPost', params, httpOptions);
  }
  static addDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/addDeptPost', params, httpOptions);
  }
  static deleteDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/deleteDeptPost', params, httpOptions);
  }
  static deleteDeptPostList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/deleteDeptPostList', params, httpOptions);
  }
  static updateDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deptInfo/updateDeptPost', params, httpOptions);
  }
  static viewDeptPost(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/deptInfo/viewDeptPost', params, httpOptions);
  }
}
